import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthConfig, NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { parseJwt } from 'src/app/utils/fn';
import queryString from 'query-string';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class AuthConfigService {

  private _decodedAccessToken: any;
  private _decodedIDToken: any;

  get decodedAccessToken() {
    return this._decodedAccessToken;
  }

  get decodedIDToken() {
    return this._decodedIDToken;
  }

  constructor(
    private readonly oauthService: OAuthService,
    private readonly router: Router,
    private readonly authConfig: AuthConfig,
    private readonly appconfig: AppConfigService,
    private http: HttpClient,
    private translate: TranslateService,
  ) {
  }

  async initAuth(): Promise<any> {
    const redirectUri = `${window.location.origin}/auth-callback`;
    const logoutUrl = `${window.location.origin}/silent-refresh.html`;
    const s = await this.appconfig.loadConfig();
    return new Promise((resolveFn, rejectFn) => {
      this.oauthService.configure({ ...s, redirectUri: redirectUri, logoutUrl: logoutUrl });
      this.oauthService.setStorage(localStorage);
      this.oauthService.tokenValidationHandler = new NullValidationHandler();
      this.oauthService.events
        .pipe(filter((e: any) => {
          return e.type === 'token_received';
        }))
        .subscribe(() => this.handleNewToken());

      this.oauthService.loadDiscoveryDocumentAndLogin().then(isLoggedIn => {
        if (isLoggedIn) {
          this.oauthService.setupAutomaticSilentRefresh();
          this.getWebMenuListByUserId();
         
          resolveFn(true);
        } else {
          this.oauthService.initImplicitFlow();
          rejectFn();
        }
      });

    });
  }

  private getWebMenuListByUserId() {
     this.translate.use('vi');
    const tokenData = parseJwt(this.oauthService.getAccessToken());
    const queryMeny = queryString.stringify({
      userId: tokenData.sub,
      webId: this.appconfig.webId ? this.appconfig.webId : null
    });
    const options = {
      headers: new HttpHeaders({
        Authorization: this.oauthService.getAccessToken(),
        'Content-Type': 'application/json',
        'Accept-Language': 'vi'
      })
    };
    this.http.get(`${this.appconfig.apiHrmConfig}/api/v1/webmanager/GetWebMenuListByUserId?` + queryMeny, options).subscribe((ressult: any) => {
      if (ressult.status === 'success') {
        this.translate.use(ressult.data.acceptLanguage);
        localStorage.setItem('currentLang', JSON.stringify(ressult.data));
        if (window.location.pathname === '/auth-callback' || window.location.pathname === '' || window.location.hash === '#/home') {
            this.router.navigateByUrl('/nhan-su/employee-overview');
          }
      }
    });
  }

  private handleNewToken() {
    this._decodedAccessToken = this.oauthService.getAccessToken();
    this._decodedIDToken = this.oauthService.getIdToken();
  }

}
